import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.967 9.333H13.3V2.667h.667a.667.667 0 1 0 0-1.334h-12a.667.667 0 1 0 0 1.334h.666v6.666h-.666a.667.667 0 1 0 0 1.334H7.3v.766l-3.033 2a.666.666 0 0 0 .366 1.234.63.63 0 0 0 .367-.114l2.3-1.52V14a.666.666 0 1 0 1.333 0v-.967l2.3 1.52a.63.63 0 0 0 .367.114.667.667 0 0 0 .367-1.22l-3.034-2v-.78h5.334a.666.666 0 1 0 0-1.334m-2 0h-8V2.667h8z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.567 4.533v2.8a.533.533 0 1 0 1.066 0v-2.8a.533.533 0 0 0-1.066 0M7.433 7.333V6A.533.533 0 1 1 8.5 6v1.333a.533.533 0 1 1-1.067 0M5.456 7.71a.533.533 0 1 1 .755-.754.533.533 0 0 1-.755.754"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })